module.exports = __webpack_public_path__ + "img/shopify.94f5dabe.png";